import { FilterFactory } from '@/features/canvas/components/FiltersAccordionContent/FilterFactory';
import { FilterTypes } from '@/features/canvas/types/filter';

export const createDefaultFilterByType = (filterType: keyof typeof FilterTypes) => {
  switch (filterType) {
    case FilterTypes.PRIORITY:
      return FilterFactory.createPriorityFilter().getFilter();
    case FilterTypes.PROGRESS_STATUS:
      return FilterFactory.createProgressStatusFilter().getFilter();
    case FilterTypes.RAG:
      return FilterFactory.createRAGFilter().getFilter();
    case FilterTypes.SIZE:
      return FilterFactory.createSizeFilter().getFilter();
    case FilterTypes.CUSTOM_SINGLE:
      return FilterFactory.createCustomSingleFilter().getFilter();
    default:
      return FilterFactory.createCustomMultiFilter().getFilter();
  }
};
